import { ReactNode } from 'react';

import { CardStyled, Wrapper } from './LandingFormWrapper.styles';

interface LandingFormWrapperProps {
  children: ReactNode;
  className?: string;
  size?: number;
}

const LandingFormWrapper = ({
  children,
  className,
  size,
}: LandingFormWrapperProps): JSX.Element => (
  <Wrapper className={className}>
    <CardStyled size={size}>{children}</CardStyled>
  </Wrapper>
);

export default LandingFormWrapper;
